import i18next from 'i18next';

i18next.addResources('es_CL', 'FooterWithPrice', {
  maxIngredientsError: 'Puedes elegir entre 1 y {{maxIngredients}} ingredientes'
});

i18next.addResources('es_ES', 'FooterWithPrice', {
  maxIngredientsError: 'Puedes elegir entre 1 y {{maxIngredients}} ingredientes'
});
